import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core'
import { Subject,Observable, of } from 'rxjs'
import { catchError } from 'rxjs/operators';



@Injectable()
export class AuthenticationQuestionsService {

  constructor(private http: HttpClient){

  }

  getAuthenticationQuestions():Observable<any>  {
    let subject = new Subject()
    setTimeout(() => {
      subject.next(SECURITY_QUESTIONS); subject.complete();},100)
    return subject
    /*const baseUrl = environment.url
    let options = {headers: new HttpHeaders({
      'Access-Control-Allow-Origin':  '*',//'https://eid.dev.wgu.edu',
      'Access-Control-Request-Method': 'POST',
      'Access-Control-Request-Headers': 'Content-Type, Authorization',
      'Content-Type':'application/json',
      'Authorization': 'Basic ' + btoa('iiqrestservice:iiqrestservice')
    })}
    let url =`${baseUrl}/rest/workflows/Get-Security-Questions/launch`
    let body ='{ "workflowArgs" : { "identityUsername" : "" } }'
    console.log('Authorization',options.headers.get('Authorization'))
    console.log('Body',body)
    console.log('Body with JSON',JSON.stringify(body))
    return this.http.post<any>(url,JSON.stringify(body),options)
            .pipe(catchError(this.handleError('getSecurityQuestions',[])))*/


  }
  private handleError<T> (operation ='operation', result?:T){
    return (error: any): Observable<T> => {
      console.error(error)
      return of(result as T)
    }
  }

}

const SECURITY_QUESTIONS:any = {
  "attributes": {
      "securityQuestions": [
          {
              "question": "What was the name of the first street you lived on?",
              "id": "ff80808144dbcc030144dbccd36d000b"
          },
          {
              "question": "What is your favorite pet's name?",
              "id": "ff80808144dbcc030144dbccd370000c"
          },
          {
              "question": "What was the name of your childhood best friend?",
              "id": "ff80808144dbcc030144dbccd373000d"
          },
          {
              "question": "What is your maternal grandmother's first name?",
              "id": "ff80808144dbcc030144dbccd375000e"
          },
          {
              "question": "Who is your favorite author?",
              "id": "ff80808144dbcc030144dbccd378000f"
          },
          {
              "question": "What was the name of the city where you met your spouse or significant other?",
              "id": "ff80808146afa0c30146afa1777d0032"
          },
          {
              "question": "What was the name of the school where you attended sixth grade?",
              "id": "ff80808146afa0c30146afa1779d0033"
          },
          {
              "question": "What was your favorite place to visit as a child?",
              "id": "ff80808146afa0c30146afa177ac0034"
          },
          {
              "question": "What was your favorite teacher's name?",
              "id": "ff80808146afa0c30146afa177b90035"
          },
          {
              "question": "What were the make and model of your first car?",
              "id": "ff80808146afa0c30146afa177c50036"
          },
          {
              "question": "Who painted your favorite painting?",
              "id": "ff80808146afa0c30146afa177d10037"
          },
          {
              "question": "Who is your favorite historical figure?",
              "id": "ff80808146afa0c30146afa177df0038"
          },
          {
              "question": "What is your favorite food?",
              "id": "ff80808146afa0c30146afa177ec0039"
          },
          {
              "question": "When you were a child, what job did you dream of having when you grew up?",
              "id": "ff80808146afa0c30146afa177f6003a"
          },
          {
              "question": "What is your mother's maiden name?",
              "id": "ff80808146afa0c30146afa177fe003b"
          },
          {
              "question": "What is your favorite color?",
              "id": "ff80808146afa0c30146afa17808003c"
          },
          {
              "question": "What was the name of the city where you were born?",
              "id": "ff80808146afa0c30146afa17810003d"
          }
      ]
  },
  "complete": false,
  "errors": null,
  "failure": false,
  "metaData": null,
  "requestID": null,
  "retry": false,
  "retryWait": 0,
  "status": null,
  "success": false,
  "warnings": null
}
